export enum StorageKeys {
  AccessToken = 'scp.auth.jwt',
  Lang = 'scp.language',
}
